module.exports = __webpack_public_path__ + "img/montagne.f5ebc502.png";